import { render, staticRenderFns } from "./SidebarPanel.vue?vue&type=template&id=8c404c6e&"
import script from "./SidebarPanel.vue?vue&type=script&lang=js&"
export * from "./SidebarPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports